import styled from 'styled-components';

export const TableWrapper = styled.div.attrs({
  className: 'col-11 mx-auto mt-5'
})`
  border: 1px solid #E0E0E0;
  border-radius: 6px;
`

export const SplitTableWrapper = styled.div.attrs({
  className: 'row col-12 mt-3 mx-0 px-0'
})`
  overflow-x: auto;
`

export const ScrollableWrapper = styled.div.attrs({
  className: 'row col-12 px-0 mx-0'
})`
  min-width: 800px;
`

export const TableLeftWrapper = styled.div.attrs({
  className: 'col-3 px-0'
})`
  /* min-width: 200px; */
  border: 1px solid #E0E0E0;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
`

export const TableRightWrapper = styled.div.attrs({
  className: 'col-9 px-0'
})`
  /* min-width: 500px; */
  border: 1px solid #E0E0E0;
  border-left: none;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;

  .react-bootstrap-table table {
    table-layout: auto;
  }
`

export const PageWrapper = styled.div.attrs(({ isMobile }) => ({
  className: 'p-4'
}))``

export const LabelCountSpan = styled.span``
